
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import RadioButton from 'element-ui/lib/radio-button';

var script = {
  name: 'PendoRadioButton',
  components: {
    ElRadioButton: RadioButton,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    value: {
      type: null,
      default: null
    },
    displayClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledLabel: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },
  computed: {
    iconProps() {
      return _objectSpread({
        size: 14
      }, this.icon);
    },

    tooltipContent() {
      if (!this.icon) {
        return null;
      }

      if (this.disabled) {
        return this.disabledLabel;
      }

      return this.label;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-radio-button"
  }, [_c('el-radio-button', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.tooltipContent,
        delay: {
          show: 100,
          hide: 0
        }
      },
      expression: "{\n            content: tooltipContent,\n            delay: {\n                show: 100,\n                hide: 0\n            }\n        }"
    }],
    class: _vm.displayClass,
    attrs: {
      "label": _vm.value,
      "name": _vm.name,
      "disabled": _vm.disabled
    }
  }, [_vm._t("default", [!_vm.icon ? [_vm._v("\n                " + _vm._s(_vm.label) + "\n            ")] : _vm._e(), _vm._v(" "), _vm.icon ? _c('pendo-icon', _vm._b({}, 'pendo-icon', _vm.iconProps, false)) : _vm._e()])], 2)], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-radio-button.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoRadioButton = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoRadioButton;
